module.exports = __webpack_public_path__ + "fonts/Cabin-Bold.6d8418d.ttf";